import { memo } from "react";
import logo from "assets/images/logo.svg";
import styled from "styled-components";
import { useMeasureForCssVar, useTouchHold } from "components/hooks";
import { MncVars } from "const";
import { useDispatch, useSelector } from "react-redux";
import { hideAllMainMenu, showAllMainMenu } from "redux/reducers/auth";
import { MenuSelector } from "redux/selector/menu-selector";

// !WTF Dont Remove This Line, WTF ERROR ???
import { CustomerSelector } from "redux/selector/customer-selector";
import { NotificationSelector } from "redux/selector/notification";
// !WTF Dont Remove This Line, WTF ERROR ???

const use = [["height", MncVars.Header]];

const MoneyConnectHeader = ({ height, setIsVisible }) => {
  const dispatch = useDispatch();
  const forceHideAllMenu = useSelector(MenuSelector.forceHideAllMenu);
  const notiList = useSelector(NotificationSelector.notificationList);
  const [headerRef] = useMeasureForCssVar({ use });
  const [headerRefForTouch] = useTouchHold(() => {
    if (forceHideAllMenu) {
      dispatch(showAllMainMenu());
    } else {
      dispatch(hideAllMainMenu());
    }
  }, 7);

  return (
    <NavHeader
      ref={(node) => {
        headerRef(node);
        headerRefForTouch(node);
      }}
      className="navbar navbar-mnc navbar-expand-lg navbar-dark"
      $height={height}
    >
      <div className="container">
        <span className="navbar-brand">
          <img src={logo} alt="logo" />
        </span>
        <div className="notification-mnc" onClick={() => setIsVisible(true)}>
          <i className="feather-icon icon-bell" />
          {notiList.length > 0 && <div className="notification-message-new">{notiList.length}</div>}
        </div>
      </div>
    </NavHeader>
  );
};

export default memo(MoneyConnectHeader);

const NavHeader = styled.nav`
  position: sticky;
  top: 0;
  z-index: 999;
  height: ${(props) => props.$height}px;
`;
